export const darkTheme = {
   main: `hsl(0, 0%, 12%)`,
   informational: `hsl(0, 0%, 24%)`,
   informationalHover: `hsl(0, 0%, 29%)`,
   header: `linear-gradient(180deg, hsla(0, 0%, 18%, 1), hsla(0, 0%, 18%, 0.3) 80%, transparent)`,
   chatRoom: `hsl(0, 0%, 18%)`,
   userMessage: `#0c8d71`,
   messageBtn: `hsl(0, 0%, 70%)`,
   messageBtnHover: `hsl(0, 0%, 80%)`,
   formContainer: `hsl(0, 0%, 18%)`,
   form: `hsl(0, 0%, 24%)`,
   formHover: `hsl(0, 0%, 29%)`,
   menuBtn: `hsla(0, 0%, 100%, 0.6)`,
   menuBtnHover: `hsla(0, 0%, 100%, 0.8)`,
   menuBtnShadow: `hsla(0, 0%, 100%, 0.8)`,
   menu: `hsl(0, 0%, 22%)`,
   menuFont: `#d9d9d9`,
   menuFontHover: `hsla(0, 0%, 100%, 0.8)`,
   menuListBtnsHover: `hsl(0, 0%, 26%)`,
   font: `#fcfcfc`,
   fontDate: `#b6b6b6`,
   container: `hsl(0, 0%, 18%)`,
   section: `hsl(0, 0%, 12%)`,
   modal: `#353535`,
   loginForm: `hsl(0, 0%, 18%)`,
};

export const lightTheme = {
   main: `hsl(0, 0%, 95%)`,
   informational: `hsl(0, 0%, 80%)`,
   informationalHover: `hsl(0, 0%, 70%)`,
   header: `hsl(0, 0%, 90%)`,
   chatRoom: `hsl(60, 100%, 99%)`,
   messageBtn: `hsl(0, 0%, 80%)`,
   messageBtnHover: `hsl(0, 0%, 70%)`,
   userMessage: `#0c8d71`,
   messageBackground: `hsl(0, 0%, 85%)`,
   formContainer: `hsl(0, 0%, 18%)`,
   form: `hsl(0, 0%, 80%)`,
   formHover: `hsl(0, 0%, 75%)`,
   menuBtn: `hsla(0, 0%, 10%, 0.8)`,
   menuBtnHover: `hsla(0, 0%, 40%, 0.8)`,
   menuBtnShadow: `transparent`,
   menu: `hsl(0, 0%, 85%)`,
   menuFont: `#2a2e30`,
   menuFontHover: `#2a2e30`,
   menuListBtnsHover: `hsl(0, 0%, 60%)`,
   font: `#2a2e30`,
   fontDate: `hsl(0, 0%, 16%)`,
   container: `hsl(0, 0%, 90%)`,
   section: `hsl(0, 0%, 80%)`,
   modal: `hsl(0, 0%, 90%)`,
   loginForm: `hsl(0, 0%, 90%)`,
};
